// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"3f6d4bf3","611":"9c8ca914"}[chunkId] + ".chunk.js";
};